import React from "react";
import PillSkeleton from "../Pill/PillSkeleton";
import styles from "./PillsGroup.module.css";

interface PillsGroupSkeletonProps {
  count?: number;
  showIcon?: boolean;
  showLabel?: boolean;
  showTooltip?: boolean;
  variant?: "default" | "info" | "success" | "warning" | "error";
}

const PillsGroupSkeleton: React.FC<PillsGroupSkeletonProps> = ({
  count = 3,
  showIcon = true,
  showLabel = true,
  showTooltip = false,
  variant = "default",
}) => {
  return (
    <div className={styles["container"]}>
      {Array.from({ length: count }).map((_, idx) => (
        <PillSkeleton
          key={idx}
          showIcon={showIcon}
          showLabel={showLabel}
          showTooltip={showTooltip}
          variant={variant}
        />
      ))}
    </div>
  );
};

export default PillsGroupSkeleton;
